import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button, Dropdown, DropdownButton } from 'react-bootstrap';
import './Odontograma.css';

const tratamientos = [
  { name: 'Pintar Color', symbol: '■■' },
  { name: 'Caries', symbol: '●' },
  { name: 'Fractura', symbol: '////' },
  { name: 'Desgaste', symbol: '░' },
  { name: 'Movilidad', symbol: '↑' },
  { name: 'Periodontitis', symbol: '----' },
  { name: 'Obturación', symbol: '■' },
  { name: 'Sellador', symbol: '●' },
  { name: 'Coronas', symbol: '□' },
  { name: 'Prótesis', symbol: '≈' },
  { name: 'Trat. de Conducto', symbol: '|' },
  { name: 'Implante', symbol: '⚙' },
  { name: 'Diente Extraído', symbol: 'X' },
];

const Odontograma = ({ dni_paciente }) => {
  const [odontograma, setOdontograma] = useState([]);
  const [editable, setEditable] = useState(false);
  const [selectedColor, setSelectedColor] = useState('');
  const [selectedTool, setSelectedTool] = useState('');

  useEffect(() => {
    const fetchOdontogramaData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/odontograma/${dni_paciente}`);
        setOdontograma(response.data || []);
      } catch (error) {
        console.error('Error al obtener datos del odontograma:', error);
      }
    };
    fetchOdontogramaData();
  }, [dni_paciente]);

  const handleToggleEditable = () => {
    setEditable(!editable);
    setSelectedColor('');
    setSelectedTool('');
  };

  const handleToothClick = async (diente, lado) => {
    if (!editable || !selectedColor || !selectedTool) return;

    const isWholeTooth = ['Coronas', 'Implante', 'Diente Extraído', 'Prótesis'].includes(selectedTool);
    const ladoFinal = isWholeTooth ? 'T' : lado;
    const existingWholeToothIndex = odontograma.findIndex(data => data.diente === diente && data.lado === 'T');

    if (existingWholeToothIndex !== -1 && selectedColor !== 'borrado') {
      // No permitir agregar otros tratamientos si hay un tratamiento de tipo T
      return;
    }

    try {
      const existingIndex = odontograma.findIndex(data => data.diente === diente && data.lado === lado);
      const existingIndex2 = odontograma.findIndex(data => data.diente === diente && data.lado === 'T');
      if (selectedColor === 'borrado') {
        if (existingIndex !== -1) {
          await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/odontograma/eliminar/${dni_paciente}/${diente}/${ladoFinal}`);
          setOdontograma(odontograma.filter(data => !(data.diente === diente && data.lado === ladoFinal)));
        }
        if (existingIndex2 !== -1) {
          await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/odontograma/eliminar/${dni_paciente}/${diente}/T`);
          setOdontograma(odontograma.filter(data => !(data.diente === diente && data.lado === 'T')));
        }
      } else {
        const simbolo = getSymbol(selectedTool);
        const direccion = (existingIndex !== -1) ? (odontograma[existingIndex].direccion + 90) % 360 : 0;
        if (existingIndex !== -1) {
          const newData = [...odontograma];
          newData[existingIndex] = { ...newData[existingIndex], color: selectedColor, simbolo, direccion };
          setOdontograma(newData);
          await axios.put(`${process.env.REACT_APP_BACKEND_URL}/odontograma/modificar/${dni_paciente}/${diente}/${ladoFinal}`, newData[existingIndex]);
        } else {
          const newEntry = { dni_paciente, diente, lado: ladoFinal, color: selectedColor, simbolo, direccion };
          setOdontograma([...odontograma, newEntry]);
          await axios.post(`${process.env.REACT_APP_BACKEND_URL}/odontograma/guardar`, newEntry);
        }
      }
    } catch (error) {
      console.error('Error al guardar cambios:', error);
    }
  };

  const getSymbol = (tool) => {
    const treatment = tratamientos.find(t => t.name === tool);
    return treatment ? treatment.symbol : '';
  };

  const getColorClass = (diente, lado) => {
    const data = odontograma.find(item => item.diente === diente && item.lado === lado);
    if (data && data.simbolo === '■■') {
      return `click-${data.color}`;
    }
    return '';
  };

  const renderSymbol = (diente, lado) => {
    const data = odontograma.find(item => item.diente === diente && item.lado === lado);
    if (!data) return null;
    const isWholeTooth = lado === 'T';
    if (data.simbolo === '■■') {
      return null;
    }
    return (
      <div className={`symbol ${data.color} ${isWholeTooth ? 'whole-tooth' : ''}`} style={{ transform: `rotate(${data.direccion}deg)` }}>
        {data.simbolo}
      </div>
    );
  };

  const renderLabels = (labels) => (
    <div className="labels">
      {labels.map((label, index) => (
        <div key={index} className="label fw-bold" style={{ fontSize: '1.5rem' }}>
          {label}
        </div>
      ))}
    </div>
  );

  const renderLabels2 = (labels) => (
    <div className="labels">
      {labels.map((label, index) => (
        <div key={index} className="label fw-bold" style={{ fontSize: '1.5rem', margin: '50px' }}>
          {label}
        </div>
      ))}
    </div>
  );

  const renderTeeth1 = (start, end, className) => {
    const teeth = [];
    for (let i = start; i >= end; i--) {
      teeth.push(
        <div key={i} className={`diente ${className}`} style={{  color: 'black', fontWeight: 'bold' }}>
          <span className="label-info">{i}</span>
          <div id={`u${i}`} className={`cuadro ${getColorClass(i, 'U')} arriba border-0  border-top `} onClick={() => handleToothClick(i, 'U')}>
            {renderSymbol(i, 'U')}
          </div>
          <div id={`l${i}`} className={`cuadro ${getColorClass(i, 'L')} izquierdo border-0  border-left  `} onClick={() => handleToothClick(i, 'L')}>
            {renderSymbol(i, 'L')}
          </div>
          <div id={`d${i}`} className={`cuadro ${getColorClass(i, 'D')} debajo border-0  border-bottom  `} onClick={() => handleToothClick(i, 'D')}>
            {renderSymbol(i, 'D')}
          </div>
          <div id={`r${i}`} className={`cuadro ${getColorClass(i, 'R')} derecha border-0  border-right `} onClick={() => handleToothClick(i, 'R')}>
            {renderSymbol(i, 'R')}
          </div>
          <div id={`c${i}`} className={`cuadro centro ${getColorClass(i, 'C')}`} onClick={() => handleToothClick(i, 'C')}>
            {renderSymbol(i, 'C')}
          </div>
          {renderSymbol(i, 'T')}
        </div>
      );
    }
    return teeth;
  };

  const renderTeeth2 = (start, end, className) => {
    const teeth = [];
    for (let i = start; i <= end; i++) {
      teeth.push(
        <div key={i} className={`diente ${className}`} style={{  color: 'black', fontWeight: 'bold' }}>
          <span className="label-info">{i}</span>
          <div id={`u${i}`} className={`cuadro ${getColorClass(i, 'U')}  arriba border-0 border-top`} onClick={() => handleToothClick(i, 'U')}>
            {renderSymbol(i, 'U')}
          </div>
          <div id={`l${i}`} className={`cuadro ${getColorClass(i, 'L')} izquierdo border-0 border-left`} onClick={() => handleToothClick(i, 'L')}>
            {renderSymbol(i, 'L')}
          </div>
          <div id={`d${i}`} className={`cuadro ${getColorClass(i, 'D')} debajo border-0 border-bottom`} onClick={() => handleToothClick(i, 'D')}>
            {renderSymbol(i, 'D')}
          </div>
          <div id={`r${i}`} className={`cuadro ${getColorClass(i, 'R')} derecha border-0 border-right`} onClick={() => handleToothClick(i, 'R')}>
            {renderSymbol(i, 'R')}
          </div>
          <div id={`c${i}`} className={`cuadro centro ${getColorClass(i, 'C')}`} onClick={() => handleToothClick(i, 'C')}>
            {renderSymbol(i, 'C')}
          </div>
          {renderSymbol(i, 'T')}
        </div>
      );
    }
    return teeth;
  };

  const renderTeeth3 = (start, end, className) => {
    const teeth = [];
    for (let i = start; i >= end; i--) {
      teeth.push(
        <div key={i} className={`diente ${className}`} style={{  color: 'black', fontWeight: 'bold' }}>
          <div id={`u${i}`} className={`cuadro ${getColorClass(i, 'U')} arriba border-0 border-top`} onClick={() => handleToothClick(i, 'U')}>
            {renderSymbol(i, 'U')}
          </div>
          <div id={`l${i}`} className={`cuadro ${getColorClass(i, 'L')} izquierdo border-0 border-left`} onClick={() => handleToothClick(i, 'L')}>
            {renderSymbol(i, 'L')}
          </div>
          <div id={`d${i}`} className={`cuadro ${getColorClass(i, 'D')} debajo border-0 border-bottom`} onClick={() => handleToothClick(i, 'D')}>
            {renderSymbol(i, 'D')}
          </div>
          <div id={`r${i}`} className={`cuadro ${getColorClass(i, 'R')} derecha border-0 border-right`} onClick={() => handleToothClick(i, 'R')}>
            {renderSymbol(i, 'R')}
          </div>
          <div id={`c${i}`} className={`cuadro centro ${getColorClass(i, 'C')}`} onClick={() => handleToothClick(i, 'C')}>
            {renderSymbol(i, 'C')}
          </div>
          {renderSymbol(i, 'T')}
          <span className="label-info2">{i}</span>
        </div>
      );
    }
    return teeth;
  };

  const renderTeeth4 = (start, end, className) => {
    const teeth = [];
    for (let i = start; i <= end; i++) {
      teeth.push(
        <div key={i} className={`diente ${className}`} style={{  color: 'black', fontWeight: 'bold' }}>
          <div id={`u${i}`} className={`cuadro ${getColorClass(i, 'U')} arriba border-0 border-top`} onClick={() => handleToothClick(i, 'U')}>
            {renderSymbol(i, 'U')}
          </div>
          <div id={`l${i}`} className={`cuadro ${getColorClass(i, 'L')} izquierdo border-0 border-left`} onClick={() => handleToothClick(i, 'L')}>
            {renderSymbol(i, 'L')}
          </div>
          <div id={`d${i}`} className={`cuadro ${getColorClass(i, 'D')} debajo border-0 border-bottom`} onClick={() => handleToothClick(i, 'D')}>
            {renderSymbol(i, 'D')}
          </div>
          <div id={`r${i}`} className={`cuadro ${getColorClass(i, 'R')} derecha border-0 border-right`} onClick={() => handleToothClick(i, 'R')}>
            {renderSymbol(i, 'R')}
          </div>
          <div id={`c${i}`} className={`cuadro centro ${getColorClass(i, 'C')}`} onClick={() => handleToothClick(i, 'C')}>
            {renderSymbol(i, 'C')}
          </div>
          {renderSymbol(i, 'T')}
          <span className="label-info2">{i}</span>
        </div>
      );
    }
    return teeth;
  };

  return (
    <div>
      {editable && (
        <div className="mb-4 text-center selector-wrapper">
          <DropdownButton id="dropdown-basic-button" className="exclude-from-pdf" title={selectedColor ? `Color: ${selectedColor}` : 'Seleccione Color'}>
            <Dropdown.Item onClick={() => { setSelectedColor('rojo'); setSelectedTool('Pintar Color'); }}>Rojo</Dropdown.Item>
            <Dropdown.Item onClick={() => { setSelectedColor('azul'); setSelectedTool('Pintar Color'); }}>Azul</Dropdown.Item>
            <Dropdown.Item onClick={() => { setSelectedColor('negro'); setSelectedTool('Pintar Color'); }}>Negro</Dropdown.Item>
            <Dropdown.Item onClick={() => { setSelectedColor('borrado'); setSelectedTool('Null'); }}>Borrado</Dropdown.Item>
          </DropdownButton>
          <DropdownButton id="dropdown-basic-button" className="exclude-from-pdf" title={selectedTool ? `Tratamiento: ${selectedTool}` : 'Seleccione Tratamiento'} disabled={selectedColor === 'borrado'}>
            {tratamientos.map(tratamiento => (
              <Dropdown.Item key={tratamiento.name} onClick={() => setSelectedTool(tratamiento.name)}>
                {tratamiento.name} <span className="float-right">{tratamiento.symbol}</span>
              </Dropdown.Item>
            ))}
          </DropdownButton>
        </div>
      )}

      <div className="odontograma" style={{  color: 'black', fontWeight: 'bold' }}fgg>
        <div className="row2">
          <div className="left-labels">{renderLabels(['V', 'P'])}</div>
          {renderTeeth1(18, 11, 'right-top')}
          <div className="separator"></div>
          {renderTeeth2(21, 28, 'left-top')}
        </div>
        <div className="row2">
          <div className="left-labels">{renderLabels(['L', 'V'])}</div>
          {renderTeeth3(48, 41, 'right-bottom')}
          <div className="separator"></div>
          {renderTeeth4(31, 38, 'left-bottom')}
        </div>
        <br />
        <div className="row3">
          <div className="row2">
            <div className="left-labels2">{renderLabels2(['DERECHA'])}</div>
          </div>
          <div>
            <div className="row2">
              <div className="left-labels">{renderLabels(['V', 'P'])}</div>
              {renderTeeth1(55, 51, 'right-top-milk')}
              <div className="separator"></div>
              {renderTeeth2(61, 65, 'left-top-milk')}
            </div>
            <br />
            <div className="row2">
              <div className="left-labels">{renderLabels(['L', 'V'])}</div>
              {renderTeeth3(85, 81, 'right-bottom-milk')}
              <div className="separator"></div>
              {renderTeeth4(71, 75, 'left-bottom-milk')}
            </div>
          </div>
          <div className="row2">
            <div className="left-labels2">{renderLabels2(['IZQUIERDA'])}</div>
          </div>
        </div>
        <div className="d-flex align-items-center w-100 justify-content-center mt-3 gap-2">
        <Button variant="secondary" className="exclude-from-pdf" onClick={handleToggleEditable}>
          {editable ? 'Cerrar' : 'Modificar Odontograma'}
        </Button>
        </div>
      </div>
    </div>
  );
};

export default Odontograma;